let _store = null;

export const setStore = (s) => {
  _store = s;
};

export const getStore = () => _store;
